// adding some validations logic for works form
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_PROJECTS_TYPES_VALIDATIONS = {
  dataForm: {
    projectType: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(55)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formProjectsTypes.js